export function runClipboardCopyWithMessage({
  navigatorObj,
  username,
  mode,
  buildPayload,
  setMessage,
  clearDelayMs = 2000,
}) {
  const payload = buildPayload(username, mode);
  navigatorObj.clipboard.writeText(payload.text);
  setMessageWithAutoClear({
    setMessage,
    type: 'success',
    text: payload.successMessage,
    clearDelayMs,
  });
}

export function clearUiMessage(setMessage) {
  setMessage({ type: '', text: '' });
}

export function setMessageWithAutoClear({
  setMessage,
  type,
  text,
  clearDelayMs = 0,
}) {
  setMessage({ type, text });
  if (clearDelayMs > 0) {
    setTimeout(() => clearUiMessage(setMessage), clearDelayMs);
  }
}
